import { Component } from '@angular/core';
import { DnButtonBaseComponent } from '../../base/dn-button-base/dn-button-base.component';

@Component({
  selector: 'dn-btn',
  templateUrl: './dn-btn.component.html',
  styleUrl: './dn-btn.component.scss',
  standalone: false,
})
export class DnBtnComponent extends DnButtonBaseComponent {}
